// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.iframe[data-v-6118c309] {\n  height: 90vh;\n  width: 100%;\n  border: 0;\n  background: var(--light);\n}\n", ""]);
// Exports
module.exports = exports;
